<div class="secondary-list-item-container">
  <div class="item-header">
    <ng-container *ngIf="url; else noLink">
      <a class="item-name" [routerLink]="url" [title]="displayName">
        {{ displayName }}
      </a>
    </ng-container>
    <ng-template #noLink>
      <div class="item-name" [title]="displayName">{{ displayName }}</div>
    </ng-template>
  </div>
  <div class="item-body">
    <div class="created-by-user-name">{{ displayUser }}</div>
    <div class="created-on">{{ displayDate | date: 'MMM d, y, h:mm a' }}</div>
  </div>
</div>
